import Daughter from "../../../entities/Daughter/ui/Daughter";

const DaughterPage = () => {
    return ( 
        <main>
            <Daughter/>
        </main>
     );
}
 
export default DaughterPage;